// Import Swiper styles
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

import Image from 'next/image'
import { A11y, Autoplay, Keyboard, Mousewheel } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { SwiperOptions } from 'swiper/types'

import styles from './SponsorSlider.module.css'

export type SponsorSliderProps = {
  title?: string
  sponsors?: {
    link?: {
      cached_url: string
    }
    src?: string
  }[]
  slidesPerView?: SwiperOptions['slidesPerView']
  autoplay?: SwiperOptions['autoplay']
}

export const PhnxSponsorSlider: React.FC<SponsorSliderProps> = ({
  title,
  sponsors,
  slidesPerView = 2,
  autoplay = {
    delay: 2500,
    disableOnInteraction: true,
  },
}) => {
  return (
    <div
      data-testid="sponsor-swiper"
      className={`${styles['sponsor-slider']} ${slidesPerView === 'auto' ? styles['fix-auto-slides-per-view'] : ''}`.trim()}
    >
      {title && <strong className={styles['title']}>{title}</strong>}

      {sponsors && sponsors.length > 0 && (
        <Swiper
          slidesPerView={slidesPerView}
          spaceBetween={30}
          keyboard={{
            enabled: true,
          }}
          loop
          mousewheel={true}
          modules={[A11y, Keyboard, Mousewheel, Autoplay]}
          className="mt-6"
          autoplay={autoplay}
        >
          {sponsors
            .filter((sponsor) => sponsor.src)
            .map((sponsor, index) => (
              <SwiperSlide key={index}>
                <a
                  aria-label={sponsor.link?.cached_url ?? sponsor.src}
                  href={sponsor.link?.cached_url ?? '#'}
                >
                  <Image
                    quality={90}
                    src={sponsor.src!}
                    width={360}
                    height={108}
                    alt=""
                    data-testid="sponsor-image"
                  />
                </a>
              </SwiperSlide>
            ))}
        </Swiper>
      )}
    </div>
  )
}
